import { Components, Theme } from '@mui/material';

const MuiList: Components<Theme>['MuiList'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(theme.spacingSizes.xxs),
    }),
  },
};

export default MuiList;
